






































































































































export default function (Component) {
  Component.options.__source = "node_modules/simple-code-editor/CopyCode.vue"
}
